import { Box, Flex, FlexProps, Heading } from '@chakra-ui/react';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { CMS } from '@waitroom/models';
import * as React from 'react';
import ReactMarkdown from 'react-markdown';
import CmsButton from '../../../../../cms/components/Button/CmsButton';
import CmsIcon from '../../../../../cms/components/Icon/CmsIcon';
import CmsVideoOrImage from '../../../../../cms/components/VideoOrImage/VideoOrImage';
import { isLinkDefined } from '../../../../../cms/utils/sanity';
import { markdownSx } from '../../../Common/styles';
import { Icon } from '../../../Icon/Icon';

export interface GridItemProps extends FlexProps {
  index?: number;
  align?: 'center' | 'left';
  colored?: boolean;
  horizontal?: boolean;
  item: CMS.GridItem;
}

const itemColors = ['red.200', 'orange.200', 'orange.50', 'red.50'];
const cLen = itemColors.length;

const GridItem = ({
  index = 0,
  align,
  colored,
  horizontal,
  item,
  ...rest
}: GridItemProps): React.ReactElement | null => {
  const { icon, align: itemAlign = align } = item;
  return (
    <Flex
      direction={horizontal ? 'row' : 'column'}
      bg={colored ? itemColors[index % cLen] : undefined}
      justifyContent={itemAlign === 'center' ? 'center' : 'flex-start'}
      textAlign={itemAlign === 'center' ? 'center' : 'left'}
      rounded="xl"
      rowGap={4}
      columnGap={[5, 6]}
      p={4}
      maxW={'560px'}
      mx="auto"
      {...rest}
    >
      <div>
        <CmsIcon icon={icon} index={index} />
      </div>
      <Flex
        rowGap="inherit"
        direction="column"
        justify="inherit"
        align="inherit"
        color={colored ? 'gray.900' : undefined}
      >
        {item.bigHeading && (
          <Heading as="h4" fontSize={['5xl', '6xl']} lineHeight="shorter" mb={2}>
            {item.bigHeading}
          </Heading>
        )}
        {item.heading && (
          <Heading as="h4" size="3xl" lineHeight="shorter">
            {item.heading}
          </Heading>
        )}
        {item.content && (
          <Box sx={markdownSx} fontSize={['md', 'lg']}>
            <ReactMarkdown>{item.content}</ReactMarkdown>
          </Box>
        )}
        {isLinkDefined(item.link) && (
          <CmsButton
            data={item.link}
            layoutBg={rest.bgColor}
            size={['sm', 'def', 'md']}
            rightIcon={<Icon icon={faArrowRight} ml="2px" />}
            justifyContent="inherit"
          >
            {item.link.text}
          </CmsButton>
        )}

        {item.video || item.image ? (
          <div>
            <CmsVideoOrImage
              video={item.video}
              image={item.image}
              size={[640, 480]}
              w="100%"
              h="auto"
              mt={4}
              borderRadius="lg"
            />
          </div>
        ) : null}
      </Flex>
    </Flex>
  );
};
export default GridItem;
